import classNames from "classnames";
import { Button, Menu, MenuTrigger, Popover } from "react-aria-components";

import CaretIcon from "../../public/svg/caret.svg";

import styles from "./dropdown.module.scss";

export interface DropdownMenuProps
    extends Omit<React.ComponentProps<typeof Menu>, "className"> {
    buttonContent: React.ReactNode;
    className?: string;
}

export { MenuItem as DropdownMenuItem } from "react-aria-components";

export function DropdownMenu({
    children,
    className,
    buttonContent,
    ...props
}: DropdownMenuProps) {
    return (
        <MenuTrigger {...props}>
            <Button className={classNames([styles.button, className])}>
                {buttonContent}
                <span aria-hidden>
                    <CaretIcon />
                </span>
            </Button>
            <Popover
                className={styles.popover}
                maxHeight={400}
                offset={0}
                placement="bottom start"
            >
                <Menu {...props} className={styles.list}>
                    {children}
                </Menu>
            </Popover>
        </MenuTrigger>
    );
}
